<template>
  <v-row class="row">
    <v-col class="col-12 text-center">
      <h2>Admin Stormwatch</h2>
    </v-col>
    <v-col class="col-6">
      <l-map
        :center="[47, 2]"
        :zoom="5"
        id="map"
        @click="clickmap"
        @zoom="zoomUpdate"
        ref="map"
      >
        <l-tile-layer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        ></l-tile-layer>

        <l-marker
          v-for="(marker, z) in radiuses"
          :lat-lng="[marker.lat, marker.lon]"
          :key="z"
        >
          <l-icon :icon-anchor="[10, 25]">
            <v-col>
              <h1>{{ z + 1 }}</h1>
            </v-col>
          </l-icon>
        </l-marker>
        <template v-for="(radius, c) in radiuses">
          <l-circle
            color="red"
            :key="`${c}c`"
            :lat-lng="[radius.lat, radius.lon]"
            :radius="parseInt(radius.radius1) * 1000"
          />
        </template>
        <template v-for="(radius, c) in radiuses">
          <l-circle
            color="orange"
            :key="`${c}d`"
            :lat-lng="[radius.lat, radius.lon]"
            :radius="parseInt(radius.radius2) * 1000"
          />
        </template>
        <template v-for="(radius, c) in radiuses">
          <l-circle
            color="yellow"
            :key="`${c}e`"
            :lat-lng="[radius.lat, radius.lon]"
            :radius="parseInt(radius.radius3) * 1000"
          />
        </template>
      </l-map>
    </v-col>
    <v-col class="col-6 panel-alerts">
      <v-btn
      elevation="0"
        @click="submitAlert"
        v-if="!radiuses.find((map) => map.id)"
        :disabled="!radiuses.length"
      >
        Envoyer
      </v-btn>
      <v-btn elevation=0 @click="updateAlerte" class="mr-3" v-else>Mettre à jour</v-btn>
      <v-btn elevation=0 :disabled="!checkLimit" @click="add_alert">+</v-btn>
      <br />
      <v-col
        :class="selected_radius == i ? 'bg-selected' : 'bg-unselected'"
        @click="selected_radius = i"
        class="selectable-v-col p-3 my-3"
        v-for="(radius, i) in radiuses"
        :key="i"
      >
        <svg
          v-if="selected_radius == i"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-arrow-right"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
          />
        </svg>
        Alerte #{{ i + 1 }}
        <br />
        <v-col :key="i">
          <v-row>
            <template v-for="(item, b) in Object.entries(radius)">
              <v-col cols="4" :key="b" v-if="!excludelist.includes(item[0])">
                <label v-if="item[0] != 'latlng'" :key="b">
                  {{ translate(item[0]) }}
                  <v-text-field
                    class="form-control"
                    filled dense
                    rounded
                    :key="b"
                    :name="item[0]"
                    :type="
                      item[0] == 'radius1' ||
                      item[0] == 'radius2' ||
                      item[0] == 'radius3' ||
                      item[0] == 'phone'
                        ? 'number'
                        : 'text'
                    "
                    step="1"
                    v-model="radius[item[0]]"
                  />
                </label>
              </v-col>
            </template>
          </v-row>
          <br />
          <v-btn elevation="0" v-if="radius.id" @click="confirmSupressID = radius.id; confirmSupress = true">
            Supprimer
          </v-btn>
          <v-btn elevation="0" v-else @click="radiuses.splice(i, 1)">Supprimer</v-btn>
        </v-col>
      </v-col>
    </v-col>
    <v-dialog v-model="confirmSupress" width="300">
      <v-card >
        <v-card-title>
          Confirmer la suppression?
        </v-card-title>
        <v-card-actions>
          <v-btn elevation="0" color="error" @click="confirmSupress = false; confirmSupressID = null">Annuler</v-btn>
            <v-spacer />
          <v-btn elevation="0" color="success" @click="deleteAlerte(confirmSupressID)">Confirmer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar top v-model="confirmUpdate" color="success">
      Mise à jour réussi
    </v-snackbar>
  </v-row>
</template>

<script>
import { LMap, LTileLayer, LMarker, LCircle, LIcon } from "vue2-leaflet";
import axios from "axios";
import { mapState } from "vuex";
export default {
  components: {
    "l-map": LMap,
    "l-tile-layer": LTileLayer,
    "l-marker": LMarker,
    "l-circle": LCircle,
    "l-icon": LIcon,
  },
  computed: {
    checkLimit()
    {
      if(this.radiuses.length >= this.$checkLimit("stormwatch_alerts")) return false
      return this.$checkLimit("stormwatch_alerts");
    },
    ...mapState(["user"]),
  },
  data: () => ({
    radiuses: [],
    map: null,
    excludelist:["id", "id_user", "is_active", "end_alert", "lon", "lat"],
    selected_radius: null,
    confirmSupress:false,
    confirmUpdate:false,
    confirmSupressID:null,
    id_user: null, //change with <?php echo $ID_USER; ?>
    translation: {
      lat: "Latitude",
      email: "Email",
      lon: "Longitude",
      phone: "Téléphone",
      name: "Nom de la ville",
      radius1: "Rayon Rouge (en km)",
      radius2: "Rayon Orange (en km)",
      radius3: "Rayon Jaune (en km)",
      id_user: "ID My",
      is_active: "Actif 0|1",
      end_alert: "Fin d'alerte 0|1",
    },
  }),
  methods: {
    translate(val) {
      return this.translation[val] || val;
    },
    zoomUpdate() {
      console.log("zoom");
      this.$refs.map.mapObject.invalidateSize();
    },
    submitAlert() {
      axios
        .post("https://api-my.previmeteo.net/stormwatch/subs", this.radiuses)
        .then(() => {
          this.confirmUpdate = true;
          this.getAlert();
        });
    },
    getAlert() {
      axios
        .get(`https://api-my.previmeteo.net/stormwatch/${this.id_user}/subs`)
        .then((res) => {
          this.radiuses = res.data;
        });
    },
    updateAlerte() {
      axios.put("https://api-my.previmeteo.net/stormwatch/subs", this.radiuses).then(()=>{
          this.confirmUpdate = true;
      });
    },
    deleteAlerte(id) {
      axios
        .delete(`https://api-my.previmeteo.net/stormwatch/subs/${id}`)
        .then(() => {
          this.getAlert();
        });
    },
    clickmap(e) {
      console.log("event", e);
      if (this.selected_radius != null) {
        this.radiuses[this.selected_radius].lat =
          Math.round(e.latlng.lat * 100) / 100;
        this.radiuses[this.selected_radius].lon =
          Math.round(e.latlng.lng * 100) / 100;
      }
    },
    add_alert() {
      this.radiuses.push({
        lat: 0,
        lon: 0,
        email: "",
        phone: "",
        name: "",
        radius1: 6,
        radius2: 15,
        radius3: 28,
        id_user: this.id_user,
      });
      this.selected_radius = this.radiuses.length - 1;
    },
  },
  mounted() {
    this.id_user = this.user.id_user;
    this.getAlert();
  },
};
</script>
 <style>
#map {
  height: 80vh;
}
.selectable-div:hover {
  background-color: rgba(160, 204, 255, 0.526);
  cursor: pointer;
}
.bg-selected {
  background-color: rgba(160, 204, 255, 0.8);
}
.bg-unselected {
  background-color: rgba(195, 219, 246, 0.526);
}
.panel-alerts {
  max-height: 80vh;
  overflow: scroll;
}
</style>